export const DESKTOP_APP_DOWNLOAD_PATH = "/descargar/windows";

// electron-builder publishes the installer under a fixed name so this URL
// always serves the newest release.
export const DESKTOP_APP_INSTALLER_URL =
  "https://github.com/LaPyme/lapyme-desktop-releases/releases/latest/download/La-Pyme-Setup.exe";
